<template>
  <div class="sidebar-nav lms-nav">
    <div @click="$emit('toggle-nav')" class="lms-nav-toggler" role="button">
      <feather :type="expanded ? 'chevron-left' : 'chevron-right'"></feather>
    </div>
    <div class="pd-t-20 pd-x-10 box-list">
      <label class="box-list-divider">
        <feather type="folder" class="mg-l-5 mg-t-5 tx-color-04"></feather>
        <span>Тухай</span>
      </label>
      <div
        @click="navhome()"
        class="media"
        :class="{ active: 0 == $route.params.bid }"
      >
        <div class="avatar avatar-sm">
          <span
            class="avatar-initial rounded-circle bd bd-gray-900 bg-transparent"
          >
            <feather type="home" class="tx-inverse" :size="16"></feather>
          </span>
        </div>
        <div class="media-body mg-l-10">
          <h6 class="tx-1 mg-b-3">{{ title }}</h6>
          <span class="tx-12"></span>
        </div>
      </div>
    </div>
    <vue-custom-scrollbar style="height: calc(100vh - 231px);">
      <div
        class="pd-t-20 pd-x-10 box-list"
        v-for="(b, i) in boxes.filter(
          b =>
            b.tasks.length || b.ot == 502 || b.attaches.length || b.forms.length
        )"
        :key="i"
        :class="{ active: $route.params.iid == 0 && b.id == $route.params.bid }"
      >
        <label @click="navopen(b)" class="box-list-divider">
          <feather type="folder" class="mg-l-5 mg-t-5 tx-color-04"></feather>
          <span>{{ b.nm }}</span>
          <!-- {{b.ot}} -->
        </label>

        <!-- <div class="d-flex">
        <span class="mg-l-auto tx-10 text-muted" v-if="boxBaseName(b)!=b.nm">{{boxBaseName(b)}}</span>
      </div> -->

        <section v-if="b.tasks.length">
          <div
            @click="subNavOpen(b, t)"
            class="media"
            v-for="(t, i) in b.tasks"
            :key="i"
            :class="{ active: t.id == $route.params.iid }"
          >
            <div class="avatar avatar-sm">
              <span
                :class="
                  `avatar-initial rounded-circle bd ${getTaskIconBg(t, b)}`
                "
              >
                <feather
                  v-if="b.ot == 114 && t.im != null && t.im.isDone"
                  class="text-white"
                  :type="getTaskIcon(b, t)"
                  :size="16"
                ></feather>
                <feather
                  v-else
                  class="tx-inverse"
                  :type="getTaskIcon(b, t)"
                  :size="16"
                ></feather>
              </span>
            </div>
            <div class="media-body mg-l-10">
              <h6 v-if="t.objectTypeId == 396" class="tx-13 mg-b-3">
                {{ t.taskEn }} {{ t.task }}
              </h6>
              <h6 v-else class="tx-13 mg-b-3">{{ t.task }}</h6>
              <div
                class="progress ht-5 mg-b-5"
                v-if="b.ot == 114 && t.percent.itemCount > 0"
              >
                <div
                  role="progressbar"
                  :class="
                    `progress-bar bg-${calcaulateProgressBg(
                      0,
                      t.percent.percent
                    )}`
                  "
                  :style="{ width: t.percent.percent + '%' }"
                >
                  <!-- <span class="tx-9">{{t.percent.percent}}%</span> -->
                </div>
              </div>
              <span class="tx-12" v-if="t.objectTypeId == 396">{{
                t.position
              }}</span>
              <span class="tx-12" v-if="t.percent != null"
                >{{ t.percent.completedItemCount }}/{{
                  t.percent.itemCount
                }}</span
              >
            </div>
          </div>
        </section>
        <section v-else-if="b.attaches.length">
          <div
            @click="subNavOpen(b, a)"
            class="media"
            v-for="(a, i) in b.attaches"
            :key="i"
            :class="{ active: a.id == $route.params.iid }"
          >
            <div class="avatar avatar-sm">
              <span
                :class="
                  `avatar-initial rounded-circle ${
                    a.isCompleted
                      ? 'bg-success bd-success'
                      : 'bg-transparent bd-gray-900'
                  }`
                "
              >
                <i
                  v-if="!a.isCompleted"
                  :class="`far ${getFileIcon(a)} tx-16 tx-${getTextColor(a)}`"
                ></i>
                <feather
                  v-else
                  type="check-square"
                  class="tx-inverse"
                  :size="16"
                ></feather>
              </span>
            </div>
            <div class="media-body mg-l-10">
              <h6 class="tx-13 mg-b-3">{{ a.t != "" ? a.t : a.n }}</h6>
              <span class="tx-12">{{ getSize(a.s) }}</span>
            </div>
          </div>
        </section>
        <section v-else-if="b.forms.length">
          <div
            @click="subNavOpen(b, f)"
            class="media"
            v-for="(f, i) in b.forms"
            :key="i"
            :class="{ active: f.id == $route.params.iid }"
          >
            <div class="avatar avatar-sm">
              <span
                class="avatar-initial rounded-circle bg-transparent bd bd-gray-900"
              >
                <feather
                  type="pen-tool"
                  class="tx-inverse"
                  :size="16"
                ></feather>
              </span>
            </div>
            <div class="media-body mg-l-10">
              <h6 class="tx-13 mg-b-3">{{ f.nm }}</h6>
              <div class="progress ht-5 mg-b-5" v-if="f.flag == 700">
                <div
                  role="progressbar"
                  :class="`progress-bar bg-${calcaulateProgressBg(f)}`"
                  :style="{ width: calcaulateProgress(f) + '%' }"
                >
                  <!-- <span class="tx-9">{{(calcaulateProgress(f)).toFixed(2)}}%</span> -->
                </div>
              </div>
              <span class="tx-12"
                >{{ f.fillingCount }} / {{ f.qCount }} / ({{ f.attemptCount }}
                {{ f.flag }} {{ f.resultCount }})</span
              >
            </div>
          </div>
        </section>
      </div>
    </vue-custom-scrollbar>
  </div>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  components: {
    vueCustomScrollbar
  },
  props: {
    title: {
      type: String,
      default: () => ""
    },
    boxes: {
      type: Array,
      default: () => []
    },
    expanded: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {};
  },
  methods: {
    boxBaseName(box) {
      let rv;
      let _ot = this.$store.state.app.groupDefaultObjects.filter(
        x => x.objectTypeId == box.ot
      );
      if (_ot.length && _ot[0].title != box.nm) {
        rv = _ot[0].title;
      } else {
        rv = box.nm;
      }
      //console.log(rv);
      return rv;
    },
    navhome() {
      this.$router.push({
        name: "lmsCourseView",
        params: {
          id: this.$route.params.id,
          bid: 0,
          iid: 0,
          bot: 0
        }
      });
    },
    navopen(box) {
      if (box.ot != 502) {
        this.$router.push({
          name: "lmsCourseView",
          params: {
            id: this.$route.params.id,
            bid: box.id,
            iid: 0,
            bot: box.ot
          }
        });
      }
      //this.$emit("sub-nav-change", {boxId: boxId, itemId: null } );
    },
    subNavOpen(box, t) {
      //&& this.lesson==undefined
      if (box.ot == 114) {
        //console.log('hicheel  rvv yavdaa');
        this.$router.push({
          name: "lmsLessonView",
          params: {
            id: t.id,
            cid: this.$route.params.id,
            bid: 0,
            iid: 0,
            bot: 0
          }
        });
      } else {
        this.$router.push({
          name: "lmsCourseView",
          params: {
            id: this.$route.params.id,
            bid: box.id,
            iid: t.id,
            bot: box.ot
          }
        });
      }
      //this.$emit("sub-nav-change", {boxId: box.id, itemId: t.id  } );
    },
    calcaulateProgress(f) {
      let rv = 0;
      rv = (f.fillingCount * 100) / f.qCount;
      return rv;
    },
    calcaulateProgressBg(f, prc) {
      let rv = "secondary";
      let perc = 0;
      if (prc != undefined) {
        perc = prc;
      } else {
        perc = (f.fillingCount * 100) / f.qCount;
      }

      if (perc <= 9) {
        rv = "warning";
      } else if (perc <= 19) {
        rv = "gray-200";
      } else if (perc <= 29) {
        rv = "gray-300";
      } else if (perc <= 39) {
        rv = "gray-400";
      } else if (perc <= 49) {
        rv = "gray-500";
      } else if (perc <= 59) {
        rv = "gray-600";
      } else if (perc <= 69) {
        rv = "gray-700";
      } else if (perc <= 79) {
        rv = "gray-800";
      } else if (perc <= 89) {
        rv = "gray-900";
      } else if (perc <= 99) {
        rv = "gray-900";
      } else if (perc == 100) {
        rv = "success-light";
      }
      //console.log(perc, rv);
      return rv;
    },
    getTaskIcon(b, t) {
      let rv = "";
      if (b.ot == 114) {
        if (t.im != null && t.im.isDone) {
          rv = "check-square";
        } else if (t.i == 1 && t.im == null) {
          rv = "lock";
        } else {
          rv = "square";
        }
      } else if (b.ot == 396) {
        rv = "user";
      } else if (b.ot == 500) {
        rv = "video";
      } else if (b.ot == 124) {
        rv = "message-square";
      } else rv = "info";
      return rv;
    },
    getTaskIconBg(t, b) {
      let rv = "";
      if (b.ot == 114) {
        if (t.im != null && t.im.isDone) {
          rv = "bd-success bg-success";
        } else if (t.i == 1 && t.im == null) {
          rv = "bd-gray-900 bg-transparent";
        } else {
          rv = "bd-gray-900 bg-transparent";
        }
      } else {
        return "bd-gray-900 bg-transparent";
      }
      return rv;
    }
  }
};
</script>

<style></style>
